import { memo } from 'react';
import { useTheme } from '@mui/material/styles';

interface Props {
  cx: number;
  cy: number;
  r: number;
}

const ChartCircle = ({ cx, cy, r }: Props) => {
  const theme = useTheme();

  return (
    <circle
      cx={cx}
      cy={cy}
      r={r}
      stroke={theme.customPalette.silver}
      fill="none"
      strokeWidth="1px"
      strokeDasharray="15px"
      strokeLinecap="round"
    />
  );
};

export default memo(ChartCircle);
